var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"widht":"13","height":"11","viewBox":"0 0 13 11"}},[_c('path',{attrs:{"fill":"currentColor","d":"M13 11H6.7v-.6h5.7V.6H6.7V0H13z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"currentColor","d":"M3 2.5l6.9 3.2L3 9V6H0v-.5h3v-3z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }